import React from "react"
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {push} from "react-router-redux";
import {setNotification} from "../../../actions/notifications-actions";
import * as types from "../../../actions/types";
import {passwordChange, profileChange, profileGet} from "../../../actions/auth-actions";
import {actions} from "react-redux-form";
import PasswordChangeForm from './forms/password-change-form';
import ProfileForm from './forms/profile-form';
import YCComponent from "../../yc-component";

class LecturerProfile extends YCComponent {

    profileFormName = 'forms.usersProfileChange';
    formName = 'forms.usersPasswordChange';

    componentWillMount() {
        this.props.reset(this.profileFormName);
        this.props.reset(this.formName);

        this.props.profileGet().then((result) => {
            if (result.type === types.AUTH_PROFILE_GET_SUCCESS) {
                this.props.change(this.profileFormName, result.payload);
            } else {
                this.props.setNotification('danger', 'Vyskytla se neočekávaná chyba.');
            }
        });
    }

    updateProfile = (values) => {
        this.props.formResetValidity(this.profileFormName);

        let promise = new Promise((resolve, reject) => {
            this.props
                .profileChange(values)
                .then((result) => {
                    if (result.type === types.AUTH_PROFILE_CHANGE_SUCCESS) {
                        this.props.setNotification('success', 'Váš profil byl změněn.');
                        resolve();
                    } else {
                        if (result.payload.status === 422 && result.payload.response) {
                            this.props.setNotification('warning', 'Nepodařilo se změnit váš profil.');
                            reject(result.payload.response.errors);
                        } else {
                            this.props.setNotification('danger', 'Vyskytla se neočekávaná chyba.');
                            reject();
                        }
                    }
                });
        });

        this.props.formSubmitFields(this.profileFormName, promise);
    };

    resetPassword = (values) => {
        this.props.formResetValidity(this.formName);

        let promise = new Promise((resolve, reject) => {
            this.props
                .passwordChange(values)
                .then((result) => {
                    this.props.change(this.formName, { password: '', password_confirmation: '', current_password: '' });
                    if (result.type === types.AUTH_PASSWORD_CHANGE_SUCCESS) {
                        this.props.setNotification('success', 'Vaše heslo bylo změněno.');
                        resolve();
                    } else {
                        if (result.payload.status === 422 && result.payload.response) {
                            this.props.setNotification('warning', 'Nepodařilo se změnit vaše heslo.');
                            reject(result.payload.response.errors);
                        } else {
                            this.props.setNotification('danger', 'Vyskytla se neočekávaná chyba.');
                            reject();
                        }
                    }
                });
        });

        this.props.formSubmitFields(this.formName, promise);
    };

    render() {
        return (
            <div className='container'>
                <div className='row'>
                    <div className={this.mainContainerClass}>
                        <h1>Nastavení</h1>
                        <div className='card'>
                            <div className='card-header bg-light'>
                                <strong>Profil</strong>
                            </div>
                            <div className='card-body'>
                                <ProfileForm model={this.profileFormName} onSubmit={this.updateProfile}/>
                            </div>
                        </div>

                        <div className='card'>
                            <div className='card-header bg-light'>
                                <strong>Změna hesla</strong>
                            </div>
                            <div className='card-body'>
                                <PasswordChangeForm model={this.formName} onSubmit={this.resetPassword}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


function mapStateToProps(state,ownProps) {
    return {
        auth: state.auth,
        forms: state.forms
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        setNotification: setNotification,
        push: push,
        profileGet: profileGet,
        profileChange: profileChange,
        passwordChange: passwordChange,
        formResetValidity: actions.resetValidity,
        formSubmitFields: actions.submitFields,
        reset: actions.reset,
        change: actions.change
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(LecturerProfile);
